import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { TManagmentStructure } from '../types';
import FormContainer from '~/modules/identification/components/FormComponents/FormContainer';
import { Grid } from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput';
import { AddRemoveBlock } from '~/components/AddRemoveBlock/AddRemoveBlock';
import { EMPTY_GOVERNING_PERSON } from '../constants';
import { AddressInfo } from '~/modules/identification/components/FormComponents/AddressInfo';
import FormAutocomplete from '~/components/FormComponents/FormAutocomplete';
import { useAddressQuery } from '~/queries/useAddressQuery';
import PersonalInfoBlock from '~/modules/identification/components/FormComponents/PersonalInfoBlock';
import { usePositionsQuery } from '~/queries/usePositionsQuery';
import FormGridItem from '~/components/FormComponents/FormGridItem';

export const GoverningPersons = () => {
  const { control } = useFormContext<TManagmentStructure>();
  const { nonAgressionCountryOptions, countryOptions } = useAddressQuery();
  const { positionOptions } = usePositionsQuery();

  const hasNoGoverningPersons = useWatch({
    control,
    name: 'hasNoGoverningPersons',
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'governingPersons',
  });

  if (hasNoGoverningPersons) return null;

  return fields.map((person, index) => (
    <FormContainer
      key={person.id}
      title={`Особа, яка входить до складу органів управління ${index + 1}`}
      hasBookmark
    >
      <PersonalInfoBlock
        section={`governingPersons.${index}`}
        isDisabledForm={hasNoGoverningPersons}
      />
      <FormGridItem>
        <FormInput
          name={`governingPersons.${index}.identificationNumber`}
          disabled={hasNoGoverningPersons}
          label="РНОКПП (за наявності)"
          placeholder="Введіть РНОКПП"
          fullWidth
          inputProps={{
            maxLength: 10,
          }}
        />
      </FormGridItem>
      <FormGridItem>
        <FormAutocomplete
          options={countryOptions}
          name={`governingPersons.${index}.citizenshipCountry`}
          disabled={hasNoGoverningPersons}
          inputProps={{
            placeholder: 'Оберіть країну громадянства',
          }}
          label="Країна громадянства"
        />
      </FormGridItem>
      <FormGridItem>
        <FormAutocomplete
          options={nonAgressionCountryOptions}
          name={`governingPersons.${index}.residenceCountry`}
          disabled={hasNoGoverningPersons}
          inputProps={{
            placeholder: 'Оберіть країну резидентства',
          }}
          label="Країна резидентства"
        />
      </FormGridItem>
      <FormGridItem>
        <FormAutocomplete
          options={positionOptions}
          name={`governingPersons.${index}.position`}
          disabled={hasNoGoverningPersons}
          inputProps={{
            placeholder: 'Оберіть посаду',
          }}
          label="Посада"
          shouldSaveLabel
        />
      </FormGridItem>
      <AddressInfo section={`governingPersons.${index}`} />
      <Grid size={12}>
        <AddRemoveBlock
          add={() => append(EMPTY_GOVERNING_PERSON)}
          remove={() => remove(index)}
          isPlusShown={fields.length <= 30}
          isMinusShown={fields.length > 1}
          plusText='Натисніть на "+" для додавання відомості про структуру управління (на підставі статутних документів, протоколу, рішення)'
          minusText='Натисніть на "-" для видалення відомості про структуру управління (на підставі статутних документів, протоколу, рішення)'
        />
      </Grid>
    </FormContainer>
  ));
};
